enum TesterTypes {
  Colorimeter,
  Diode,
  WetLeakage,
  EL,
  Flash,
  IAM,
  VisualInspection,
  InsulationTest,
}

export default TesterTypes;
